export default {
    'searchList': {
        'searchTxt': [{
            'name': '发车单号',
            'value': 'dispatchNo',
            'type': 'input',
            'unfold': true,
            'span': 4
        }, {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'beginDate',
            'endTime': 'endDate',
            'startPlaceholder': '创建开始日期',
            'endPlaceholder': '创建结束日期',
            'type': 'time',
            'unfold': true,
            'timeNum': 3,
            'span': 7
        }, {
            'name': '状态',
            'value': 'status',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'optionNum': 'S_F_FLAG',
            'multiple': false,
            'options': []
        }],
        'unfoldState': false,
        'advancedBtn': true
    },
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'fixedSeletionColumn': true,
        'columns': [
            {
                'label': '发车单号',
                'prop': 'dispatchNo',
                'width': '148px',
                'sort': true
            },
            {
                'label': '发车平台',
                'prop': 'siteName',
                'width': '120px',
                'sort': true
            },
            {
                'label': '发货地址',
                'prop': 'senderAddr',
                'width': '180px',
                'sort': true
            },
            {
                'label': '发货详细地址',
                'prop': 'senderDetailAddr',
                'width': '140px',
                'sort': true
            },
            {
                'label': '收货地址',
                'prop': 'receiverAddr',
                'width': '180px',
                'sort': true
            },
            {
                'label': '收货详细地址',
                'prop': 'receiverDetailAddr',
                'width': '140px',
                'sort': true
            },
            {
                'label': '收货人',
                'prop': 'receiver',
                'width': '90px',
                'sort': true
            },
            {
                'label': '收货人电话',
                'prop': 'receiverContactWay',
                'width': '100px',
                'sort': true
            },
            {
                'label': '司机',
                'prop': 'driver',
                'width': '86px',
                'sort': true
            },
            {
                'label': '司机电话',
                'prop': 'driverContactWay',
                'width': '110px',
                'sort': true
            },
            {
                'label': '车牌',
                'prop': 'vehicleCard',
                'width': '82px',
                'sort': true
            },
            {
                'label': '身份证号',
                'prop': 'driverCard',
                'width': '120px',
                'sort': true
            },
            {
                'label': '运输成本',
                'prop': 'allFreight',
                'width': '90px',
                'sort': true
            },
            {
                'label': '状态',
                'prop': 'statusText',
                'width': '80px',
                'sort': true
            },
            {
                'label': '返回结果',
                'prop': 'result',
                'width': '110px',
                'sort': true
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '160px',
                'sort': true
            },
            {
                'label': '是否抵达',
                'prop': 'isArriName',
                'width': '100px',
                'sort': true
            },
            {
                'label': '是否已上传回单',
                'prop': 'isUploadName',
                'width': '100px',
                'sort': true
            },
            {
                'label': '承运开始时间',
                'prop': 'depTime',
                'width': '160px',
                'sort': true
            },
            {
                'label': '接单时间',
                'prop': 'receiveTime',
                'width': '160px',
                'sort': true
            },
            {
                'label': '承运结束时间',
                'prop': 'arriTime',
                'width': '160px',
                'sort': true
            }
        ],
        'action': [
            {
                'type': 'text',
                'label': '编辑',
                'size': 'mini',
                'event': 'edit'
            },
            {
                'type': 'text',
                'label': '更新',
                'size': 'mini',
                'event': 'update'
            }
        ],
        'leftOperation': true,
        'leftWidth': 100
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50]
    },
    searchTotalTitle: [
        {
            'name': '服务平台',
            'value': 'siteName',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'tableConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'advanceUrl': '/searchPlatform',
            'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
            'advanceCode': 'advanceCode'
        },
        {
            'name': '是否抵达',
            'value': 'isArri',
            'type': 'select',
            'options': [
                { 'value': 'Y', 'label': '是' },
                { 'value': 'N', 'label': '否' }
            ]
        },
        {
            'name': '车牌',
            'value': 'vehicleCard',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'licensePlateNumber', 'value': '车牌' },
                { 'prop': 'cargoVolumeStr', 'value': '载货体积' },
                { 'prop': 'cdegNameCn', 'value': '车型' }
            ],
            'tableConfig': [
                { 'prop': 'licensePlateNumber', 'value': '车牌' },
                { 'prop': 'cargoVolume', 'value': '载货体积' },
                { 'prop': 'cdegNameCn', 'value': '车型' }
            ],
            'advanceUrl': 'suCar/searchByConditions',
            'cbParams': ['licensePlateNumber#vehicleCard']
        },
        {
            'name': '是否已上传回单',
            'value': 'isUpload',
            'type': 'select',
            'options': [
                { 'value': 'Y', 'label': '是' },
                { 'value': 'N', 'label': '否' }
            ]
        },
        {
            'name': '司机',
            'value': 'driver',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'name', 'value': '司机' },
                { 'prop': 'encuMobile', 'value': '电话' }

            ],
            'tableConfig': [
                { 'prop': 'name', 'value': '司机' },
                { 'prop': 'encuMobile', 'value': '电话' }
            ],
            'advanceUrl': 'suDriver/searchByConditions',
            'cbParams': ['name#driver']
        }
    ]
};